/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-sequences */
import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Typography,
  Container,
  Box,
  IconButton,
  InputAdornment,
  CircularProgress,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import Navbar from './Navbar';
import Footer from './Footer';
import { variables } from './Variables';

function LoginPage() {
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.clear();
  }, []);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  const submit = async (data) => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const raw = JSON.stringify({
      UserId: data.email.trim(),
      Password: data.password.trim(),
      ProcessName: 'SimpliSafePortal',
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    await fetch(`${variables.BASE_URL}Login`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.IsSuccess !== false) {
          localStorage.setItem('loginID', JSON.stringify(result));
          if (result?.activityDetail.length > 0) {
            navigate(`/${result?.activityDetail[0]?.PageName}`);
          } else if (result?.inventoryDetail.length > 0) {
            navigate(`/${result?.inventoryDetail[0]?.PageName}`);
          } else if (result?.dashboardDetail.length > 0) {
            navigate(`/${result?.dashboardDetail[0]?.PageName}`);
          } else if (result?.summaryDetail.length > 0) {
            navigate(`/${result?.summaryDetail[0]?.PageName}`);
          } else if (result?.skuDetail.length > 0) {
            navigate(`/${result?.skuDetail[0]?.PageName}`);
          }
        } else {
          navigate('/');
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: result.Reason,
          }).then((result1) => {
            if (result1.isConfirmed) {
              setValue('password', '');
              setTimeout(() => {
                document.getElementById('password').focus();
              }, 300);
            }
          });
        }
        setLoading(false);
      })
      .catch(
        () => (
          'error',
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
          })
        ),
      );
    setLoading(false);
  };

  return (
    <>
      <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full ">
        <Navbar />
      </div>
      <Container maxWidth="xs">
        <Box mt={8} mb={3}>
          <Typography component="h1" variant="h3">
            Sign in
          </Typography>
        </Box>
        <form noValidate onSubmit={handleSubmit(submit)}>
          <TextField
            autoComplete="off"
            autoFocus
            variant="outlined"
            margin="normal"
            fullWidth
            id="email"
            label="User Id"
            name="email"
            {...register('email', { required: true })}
            error={!!errors.email}
            helperText={errors.email ? 'User ID is required' : ''}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type={showPassword ? 'text' : 'password'}
            id="password"
            {...register('password', { required: true })}
            error={!!errors.password}
            helperText={errors.password ? 'password is required' : ''}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowPassword}
                    onMouseDown={(event) => event.preventDefault()}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          {loading ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                justifyItems: 'end',
                marginTop: '100px',
              }}
            >
              <CircularProgress
                thickness={3}
                size={40}
                sx={{ marginRight: '20px' }}
              />
              <Typography variant="h6">Loading...</Typography>
            </Box>
          ) : (
            <Box mt={2}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
              >
                Sign In
              </Button>
            </Box>
          )}
        </form>
      </Container>
      <div>
        <Footer />
      </div>
    </>
  );
}

export default LoginPage;
